import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Map.css";
import { Link } from "react-router-dom";

const Map = () => {
  const [fetchedData1, setFetchedData1] = useState([]);
  const [fetchedData2, setFetchedData2] = useState([]);

  const fetchdata1 = async () => {
    try {
      const response1 = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Advertisement_Shopimage1"
      );
      // console.log(response1.data, "response.data");
      setFetchedData1(response1.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchdata2 = async () => {
    try {
      const response2 = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Advertisement_Shopimage2"
      );
      // console.log(response2.data, "response.data");
      setFetchedData2(response2.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchdata1();
    fetchdata2();
  }, []);

  return (
    <div className="map-container">
      {/* <div className="breadcrumb">
        <Link to="/" className="breadcrumb-link">
          Home
        </Link>{" "}
        / <span>ContactUs</span>
      </div> */}

      <div className="row">
        {/* Left column for Map */}
        <div className="col-4">
          <div className="map-frame">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4221.0236446861545!2d80.23160797342246!3d13.036575564766292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5266ff8d27f5cf%3A0x1722d3ff7006c459!2sKalanjiyam%20Boutique%20(Branch%201)%2C%20Mothilal%20street!5e1!3m2!1sen!2sin!4v1763792905366!5m2!1sen!2sin"              width="100%"
              height="300%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
            
          </div>
        </div>

        {/* Middle column for Image 1 */}
        {fetchedData1?.map((item) => (
          <>
            <div className="col-4">
              <div className="image-frame">
                <img
                  src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                  alt="Placeholder"
                  width="100%"
                  height="250%"
                  loading="lazy"
                  style={{
                    objectFit: "cover",
                    borderRadius: "5px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                />
              </div>
            </div>
          </>
        ))}

        {/* Right column for Image 2 */}
        {fetchedData2?.map((item) => (
          <>
            <div className="col-4">
              <div className="image-frame">
                <img
                  src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                  alt="Placeholder"
                  width="100%"
                  height="250%"
                  loading="lazy"
                  style={{
                    objectFit: "cover",
                    borderRadius: "5px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                />
              </div>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default Map;
